export const toggleModal = "toggleModal"
export const ADD_CATEGORY_TO_LIST = "ADD_CATEGORY_TO_LIST"
export const UPDATE_CATEGORY_IN_LIST = "UPDATE_CATEGORY_IN_LIST"
export const DELETE_CATEGORY_FROM_LIST = "DELETE_CATEGORY_FROM_LIST"
export const ADD_CATEGORIES_TO_LIST = "ADD_CATEGORIES_TO_LIST"
